module.exports = __webpack_public_path__ + "Flag-262.945ff5340c5dee78e7e450627d0569eb.svg";